import { Icon, Toast } from '../atomic';
import * as S from './ErrorBoundaryLayout/ErrorBoundaryLayout.styled';

export default function ChatRoomErrorBoundary() {
  const handleReloadClick = () => {
    window.location.reload();
  };
  return (
    <>
      <S.Container>
        <S.InfoBox>
          <p>
            SERVER ERROR <br /> failed get chat data
          </p>
        </S.InfoBox>

        <S.ButtonBox>
          <S.Button onClick={handleReloadClick}>
            <Icon size={20} iconName='Reset' />
            <span>retry</span>
          </S.Button>
        </S.ButtonBox>
      </S.Container>
      <Toast type='error' text='something went wrong' />
    </>
  );
}
